var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommercialIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.6,
    height: 18,
    viewBox: "0 0 21.6 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 89"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 128",
    d: "M28.88 40.543h-.72v-9.36a1.442 1.442 0 0 0-1.44-1.44h-5.76v-4.32a1.442 1.442 0 0 0-1.44-1.44h-8.64a1.442 1.442 0 0 0-1.44 1.44v15.12h-.72a.72.72 0 0 0 0 1.44h20.16a.72.72 0 0 0 0-1.44zm-10.8-6.48a.72.72 0 0 1-.72.72h-2.88a.72.72 0 1 1 0-1.44h2.88a.72.72 0 0 1 .72.72zm-5.04-6.48h2.88a.72.72 0 1 1 0 1.44h-2.88a.72.72 0 0 1 0-1.44zm0 9.36h2.88a.72.72 0 1 1 0 1.44h-2.88a.72.72 0 1 1 0-1.44zm7.92-5.76h5.76v9.36h-5.76z",
    transform: "translate(-8 -23.983)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 129",
    d: "M170.154 131.583h-1.44a.72.72 0 0 0 0 1.44h1.44a.72.72 0 0 0 0-1.44zm-1.44-2.16h1.44a.72.72 0 0 0 0-1.44h-1.44a.72.72 0 0 0 0 1.44z",
    transform: "translate(-153.594 -118.623)",
    style: {
      fill: "#bfbfbf"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercialIcon);
export default __webpack_public_path__ + "static/media/commercial-icon.e0b6d12c6a047613ff32020627cd89f2.svg";
export { ForwardRef as ReactComponent };